import PersonAddIcon from "@mui/icons-material/PersonAdd";

const PersonAdd = (props: any) => {
  return <PersonAddIcon {...props} />;
};

export default PersonAdd;
